export default {"src":"/_next/static/media/reddend-zwemmen.83ae2820.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};